import { Directive, ElementRef, HostBinding, Input } from '@angular/core';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';
import { isNotBlank } from '@app/utils/string';

@Directive({
  selector: '[portalDropdownItem]',
  standalone: false,
})
export class DropdownItemDirective {
  /**
   * Right now only the "danger" variant is styled (dropdown-item--danger).
   */
  @Input()
  variant?: BootstrapSemanticVariation;

  get nativeElement(): HTMLElement {
    return this._elementRef.nativeElement;
  }

  @HostBinding('class')
  get variantClassName(): string {
    return [`dropdown-item`, 'tippy-item', this.variant ? `dropdown-item--${this.variant}` : '']
      .filter(isNotBlank)
      .join(' ');
  }

  constructor(private _elementRef: ElementRef) {}
}
